import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { UpdateGate } from './components/UpdateGate.js';
import { AuthProvider, useAuth } from './core/auth.js';
import { LoginPage } from './core/LoginPage.js';
import { getChannel, isNative, loadNativeInfo } from './core/native.js';
import { HomePage } from './desktop/HomePage.js';
import './styles.css';

/**
 * Kanal seçimi burada yapılır: APK'da mobil ekranlar, tarayıcıda masaüstü.
 * Mobil ekran seti Faz 4'te eklenecek; şimdilik her iki kanal da masaüstü
 * arayüzünü kullanıyor.
 */
function App() {
  const { user, loading } = useAuth();
  const [nativeHazir, setNativeHazir] = useState(!isNative());

  /**
   * Native köprü bilgisi (sürüm, donanım okuyucu) açılışta bir kez okunur.
   * Ekranlar bu bilgiye senkron eriştiği için önce yüklenmesi gerekiyor.
   */
  useEffect(() => {
    if (nativeHazir) return;
    void loadNativeInfo().finally(() => setNativeHazir(true));
  }, [nativeHazir]);

  if (!nativeHazir) {
    return <div className="yukleniyor">Yükleniyor…</div>;
  }

  if (loading) {
    return <div className="yukleniyor">Yükleniyor…</div>;
  }

  if (!user) {
    return <LoginPage />;
  }

  const channel = getChannel();
  if (channel === 'mobile') {
    // TODO(Faz 4): mobile/ScanPage — tarama odaklı arayüz
    return <HomePage />;
  }

  return <HomePage />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Güncelleme kapısı en dışta: zorunlu güncellemede oturum bile açılmaz. */}
    <UpdateGate>
      <AuthProvider>
        <App />
      </AuthProvider>
    </UpdateGate>
  </StrictMode>,
);
